import { selectBillingFormValues } from './selectors'

const EMPTY_FORM_VALUES = {}

export const buildOnboardingCtx = (state) => ({
  user: state.app.user,
  services_networks: state['services/network'],
  // Профили из активного способа оплаты — именно их видит селект формы биллинга
  // (с актуальным status). Стор finance/payment-profiles на топапе не загружается.
  payment_profiles:
    state.billing?.activeMethod?.payment_profiles ??
    state['finance/payment-profiles']?.paymentProfiles?.data,
  form: state.form,
  billingFormValues: selectBillingFormValues(state.form) || EMPTY_FORM_VALUES,
})
